import {
  Component,
  EventEmitter,
  inject,
  input,
  Input,
  OnChanges,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FinancialProductEnum,
  grace,
  irregularPayments,
  payments,
  specialPayments,
} from '../../../standard-quote/model/standard-quote.model';
import { ModalService } from '@app/components/modal/modal.service';
import { OpenQuoteService } from '@app/pages/quote/open-quote/services/open-quote-service.service';
import { FinancialCalculatorService } from '@app/pages/quote/open-quote/services/financial-calculator.service';
import { Payment } from '../../../standard-quote/model/standard-payments.model';
import { BaseComponent } from '@app/components/base/base.component';
import { quoteEnum } from '@app/components/grace-special-payments/quote-enum.model';
import { paymentType } from '../../model/open-quote.model';
import { NotificationService } from '@app/services/notifications.service';
import { OpenQuoteValidationsService } from '@app/pages/quote/open-quote/services/open-quote-validations.service';
import { environment } from '@env/environment.local';

// Cambio para merge
@Component({
  template: '',
})
export class ListSpecialPaymentsGracePeriodOpenQuoteWrapper
  extends BaseComponent
  implements OnInit, OnChanges
{
  // Servicios
  private readonly financialService = inject(FinancialCalculatorService);
  private readonly quoteService = inject(OpenQuoteService);
  private readonly modalService = inject(ModalService);
  private readonly validationsService = inject(OpenQuoteValidationsService);

  // View childs
  @ViewChild('templateConfirmation') template!: TemplateRef<any>;
  @ViewChild('modalPayments') templateModalPayments!: TemplateRef<any>;

  // Inputs
  @Input() specialPayments: specialPayments[];
  @Input() grace: grace[];
  @Input() irregularPayments: irregularPayments[];
  @Input() payments: payments[];
  @Input() idQuote: any;
  @Input() idDeal: any;
  @Input() isEdit: boolean;
  @Input() financialProduct: FinancialProductEnum;
  @Input() quoteType: quoteEnum;
  @Input() financialAmount: any;
  isCalculateDisable = input<boolean>(false);

  // Outouts
  @Output() updateSpecialPayments: EventEmitter<any> = new EventEmitter();
  @Output() updateGrace: EventEmitter<any> = new EventEmitter();
  @Output() updateIrregularPayments: EventEmitter<any> = new EventEmitter();

  // Signals
  readonly menuActive = signal<string>('');

  // Atributos
  isLoading: boolean = false;
  period: any;
  periodList: any[];
  listPayments: any[] = [];
  canBeDeleted = false;
  title: string = 'Eliminar pago';
  subtitle: string = '';
  btn1: string = 'Cancelar';
  btn2: string = 'Eliminar';
  isActivePaymentFixed = environment.active_payment_fixed;

  constructor(notificationService: NotificationService) {
    super(undefined, undefined, notificationService);
  }

  ngOnDestroy() {
    this.modalService.component = null;
    this.modalService.closeModal();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['specialPayments'] ||
      changes['grace'] ||
      changes['irregularPayments']
    ) {
      this.listPayments = [];
      if (this.specialPayments.length > 0) {
        this.specialPayments;
        this.specialPayments.map((i) => {
          this.listPayments.push({
            ...i,
            paymentDate: i.specialPaymentDate,
            paymentType: 'SPECIAL_PAYMENT',
          });
        });
        this.listPayments.sort((a, b) => a.period - b.period);
      }
      if (this.grace.length > 0) {
        this.grace.map((i) => {
          this.listPayments.push({
            ...i,
            paymentDate: i.gracePeriodDate,
            paymentType: 'GRACE_PERIOD',
          });
        });
      }
      if (this.irregularPayments.length > 0) {
        this.irregularPayments;
        this.irregularPayments.map((i) => {
          this.listPayments.push({
            ...i,
            paymentDate: i.irregularPaymentDate,
            paymentType: 'IRREGULAR_PAYMENT',
          });
        });
        this.listPayments.sort((a, b) => a.period - b.period);
      }
      this.listPayments.sort((a, b) => a.period - b.period);
    }
    this.periodList = this.payments.filter((period) => {
      return (
        !this.grace.some((g) => g.period == period.period) &&
        !this.specialPayments.some((sp) => sp.period == period.period) &&
        !this.irregularPayments.some((irr) => irr.period == period.period)
      );
    });
  }

  ngOnInit() {}

  getApplyTo(applyTo: string): string {
    if (applyTo == 'CAPITAL') {
      return 'Capital';
    } else if (applyTo == 'INTEREST') {
      return 'Interés';
    } else if (applyTo == 'TOTAL') {
      return 'Total';
    }
    return '';
  }

  getPaymentType(paymentType: string) {
    if (paymentType == 'SPECIAL_PAYMENT') {
      return 'Pago especial';
    } else if (paymentType == 'GRACE_PERIOD') {
      return 'Período de gracia';
    } else if (paymentType == 'IRREGULAR_PAYMENT') {
      return 'Pago irregular';
    }
    return '';
  }

  getPaymentClass(paymentType: string) {
    if (paymentType == 'SPECIAL_PAYMENT') {
      return 'pagoEspecial';
    } else if (paymentType == 'GRACE_PERIOD') {
      return 'periodoGracia';
    } else if (paymentType == 'IRREGULAR_PAYMENT') {
      return 'pagoIrregular';
    }
    return '';
  }

  closeMenuOptions() {
    this.menuActive.set('');
  }

  toggleMenuOptions(e: MouseEvent, updated: string) {
    e.preventDefault();
    this.menuActive.update((value) => (value !== '' ? '' : updated));
  }

  getRowKey(id: string, i: number) {
    return `${id}-${i}`;
  }

  isMenuRowOpen(id: string) {
    return this.menuActive() === id;
  }

  closeModal() {
    this.modalService.closeModal();
  }

  openModalConfirmation(payment: any) {
    this.subtitle = `¿Confirma la eliminación del ${
      payment.paymentType == 'SPECIAL_PAYMENT'
        ? 'pago especial'
        : payment.paymentType == 'GRACE_PERIOD'
        ? 'período de gracia'
        : 'pago irregular'
    }?`;
    this.btn1 = 'Cancelar';
    this.btn2 = 'Eliminar';
    this.modalService.component = this.template;
    this.modalService.openModal();
    this.period = payment;
    this.period = this.period;
    this.menuActive.set('');
  }

  // deleteModal(payment: any) {
  //   const dialogRef = this.dialog.open(ModalConfirmationComponent, {
  //     data: {
  //       title: 'Eliminar pago',
  //       subtitle: `¿Confirma la eliminación del ${
  //         payment.paymentType == 'SPECIAL_PAYMENT'
  //           ? 'pago especial'
  //           : 'período de gracia'
  //       }?`,
  //       btn1: 'Cancelar',
  //       btn2: 'Eliminar',
  //     },
  //     width: '540px',
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     this.delete(payment);
  //   });
  // }

  edit(period: any) {
    let periodSelected: any;
    if (period.paymentType == 'SPECIAL_PAYMENT') {
      periodSelected = this.specialPayments.find(
        (i) => i.period == period.period
      );
    } else if (period.paymentType == 'GRACE_PERIOD') {
      periodSelected = this.grace.find((i) => i.period == period.period);
    } else {
      periodSelected = this.irregularPayments.find(
        (i) => i.period == period.period
      );
    }

    let model = {};

    if (periodSelected) {
      model = new Payment(periodSelected, period.paymentDate);
    } else {
      model = {
        id: null,
        period: period.period,
        paymentDate: period.paymentDate,
        paymentType: null,
      };
    }
    this.period = model;
    this.period = { ...this.period, paymentType: period.paymentType };
    this.menuActive.set('');
    this.modalService.component = this.templateModalPayments;
    this.modalService.openModal();
  }

  newSpecialPayment() {
    const model = {
      id: null,
      period: null,
      paymentDate: null,
    };
    this.period = model;
    this.periodList = this.periodList
      .filter((i) => i.period != 0)
      .map((i) => {
        return { period: i.period, paymentDate: i.paymentDate };
      });
    this.modalService.component = this.templateModalPayments;
    this.modalService.openModal();
  }

  update(payment: any) {
    if(this.isActivePaymentFixed) {
      const validacion = this.validationsService.validateGracePeriodInAllPeriods(payment, this.payments, this.grace);
      if(validacion) {
       this.showNotificationError(
         'No es posible que todos los periodos sean periodos de gracia aplicados al total.'
       );
       return;
      }
    }

    if (payment.paymentType == 'SPECIAL_PAYMENT') {
      this.updateSpecialPayments.emit(
        this.financialService._updatePayment(payment, this.specialPayments)
      );
    } else if (payment.paymentType == 'GRACE_PERIOD') {
      this.updateGrace.emit(
        this.financialService._updatePayment(payment, this.grace)
      );
    } else if (payment.paymentType == 'IRREGULAR_PAYMENT') {
      this._updateIrregularPayment(payment);
    }
  }

  _updateIrregularPayment(irregularPayment: any) {
    let irregularPaymentSelected = {
      ...irregularPayment,
      irregularPaymentDate: irregularPayment.paymentDate,
    };
    let amount: number = 0;
    this.irregularPayments.map((i) => (amount += i.amount));
    amount = Number(amount) + Number(irregularPayment.amount);
    if (amount > this.financialAmount) {
      this.showNotificationError(
        'La suma de los montos ingresados excede el monto a financiar.'
      );
    } else {
      this.updateIrregularPayments.emit(
        this.financialService._updatePayment(
          irregularPaymentSelected,
          this.irregularPayments
        )
      );
    }
  }

  delete(payment: any) {
    if (payment.paymentType == 'SPECIAL_PAYMENT') {
      this.deleteSpecialPayment(payment);
    } else if (payment.paymentType == 'GRACE_PERIOD') {
      this.deleteGrace(payment);
    } else if (payment.paymentType == 'IRREGULAR_PAYMENT') {
      this.deleteIrregularPayment(payment);
    }
  }

  deleteSpecialPayment(period: any) {
    this.modalService.component = null;
    this.modalService.closeModal();
    if (!period.id) {
      this.specialPayments = this.specialPayments.filter(
        (i) => i.id != period.id
      );
      this.updateSpecialPayments.emit(this.specialPayments);
      return;
    }
    this.isLoading = true;
    this.quoteService
      .deleteSpecialPayment(this.idQuote, this.idDeal, period.id)
      .subscribe({
        next: (response) => {
          this.specialPayments = this.specialPayments.filter(
            (i) => i.id != period.id
          );
          this.updateSpecialPayments.emit(this.specialPayments);
          this.showNotificationSuccess(
            'Se ha eliminado con éxito el pago especial.'
          );
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          this.showNotificationError(
            'Ha ocurrido un error al eliminar pago especial.'
          );
        },
      });
  }

  deleteIrregularPayment(period: any) {
    this.modalService.component = null;
    this.modalService.closeModal();
    if (!period.id) {
      this.irregularPayments = this.irregularPayments.filter(
        (i) => i.id != period.id
      );
      this.updateIrregularPayments.emit(this.irregularPayments);
      return;
    }
    this.isLoading = true;
    this.quoteService
      .deleteIrregularPayments(this.idQuote, this.idDeal, period.id)
      .subscribe({
        next: (response) => {
          this.irregularPayments = this.irregularPayments.filter(
            (i) => i.id != period.id
          );
          this.updateIrregularPayments.emit(this.irregularPayments);
          this.showNotificationSuccess(
            'Se ha eliminado con éxito el pago irregular.'
          );
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          this.showNotificationError(
            'Ha ocurrido un error al eliminar pago irregular.'
          );
        },
      });
  }

  deleteGrace(period: any) {
    this.modalService.component = null;
    this.modalService.closeModal();
    if (!period.id) {
      this.grace = this.grace.filter((i) => i.id != period.id);
      this.updateGrace.emit(this.grace);
      return;
    }
    this.isLoading = true;
    this.quoteService
      .deleteGrace(this.idQuote, this.idDeal, period.id)
      .subscribe({
        next: (response) => {
          this.grace = this.grace.filter((i) => i.id != period.id);
          this.updateGrace.emit(this.grace);
          this.showNotificationSuccess(
            'Se ha eliminado con éxito el período de gracia.'
          );
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          this.showNotificationError(
            'Ha ocurrido un problema al eliminar período de gracia.'
          );
        },
      });
  }
}
